import styled from "styled-components";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function ToolHeading(props) {
  const { title, description, showCloseIcon, icon, onClose, children, onMouseEnter, onMouseLeave, spinning } = props;
  return (
    <ToolHeadingContainer onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <TitleContainer>
        <Title $spinning={spinning}>
          {icon}
          {title}
        </Title>
        <ControlsContainer>
          {children}
          {showCloseIcon && (
            <CloseButton onClick={onClose}>
              <KeyboardArrowDownIcon />
            </CloseButton>
          )}
        </ControlsContainer>
      </TitleContainer>
      {description && <Description>{description}</Description>}
    </ToolHeadingContainer>
  );
}

const ToolHeadingContainer = styled.div.attrs({
  className: 'ToolHeadingContainer'
})`
  position: fixed;
  top: 0px;
  left: 0px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 21px 20px 22px;
  width: 100%;
  background: white;
  box-shadow: 0px 0px 5px lightgray;
  z-index: 1;
  box-sizing: border-box;
  @media screen and (max-width: 640px) {
    padding: 26px 18px 22px;
    box-shadow: unset;
    background: black;
  }
`;

const TitleContainer = styled.div.attrs({
  className: 'TitleContainer'
})`
  display: flex;
  align-items: center;
`;

const Title = styled.span.attrs({
  className: 'Title'
})`
  font-family: "Roboto";
  font-weight: 700;
  font-size: 17px;
  line-height: 20.29px;
  letter-spacing: -0.32px;
  color: black;
  display: flex;
  align-items: center;
  gap: 8px;
  @media screen and (max-width: 640px) {
    color: white;
  }

  img {
    animation: rotate 8s linear infinite;
    animation-duration: ${props => props.$spinning ? '3s' : '8s'};
    transform-origin: center center;
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
`;

const Description = styled.p.attrs({
  className: 'Description'
})`
  font-family: pt sans;
  font-weight: 700;
  font-size: 14px;
  line-height: 15.53px;
  letter-spacing: -0.32px;
  margin: 0;
  margin-top: 5px;
  @media screen and (max-width: 640px) {
    color: white;
    font-weight: 400;
  }
`;

const ControlsContainer = styled.div.attrs({
  className: 'ControlsContainer'
})`
  display: flex;
  align-items: center;
  gap: 5px;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
`;

const CloseButton = styled.button.attrs({
  className: 'CloseButton'
})`
  background: none;
  border: none;
  cursor: pointer;
  color: #B2BEB5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: black;
  height: 30px;
  width: 30px;
  &:hover {
    transition: color 0.2s;
    background: #F2F2F2;
  }

  @media screen and (max-width: 640px) {
    color: #B2BEB5;
    &:hover {
      color: white;
      transition: color 0.2s;
    }
  }
`;